<!-- Login Art -->
<div class="art" [ngSwitch]="art">

  <!-- Sign Up -->
  <ng-container *ngSwitchCase="'sign-up'">
    <div class="art__text">
      <h3>Get started with a free account</h3>
      <h1>Access the only 3D human body platform packed with hundreds of interactive models that visualize anatomical structures, conditions, and treatments</h1>
      <p>
        <span class="text-light">Business user?</span>
        <br/><span class="text-xlight"><a class="art__link" href="https://www.biodigital.com/customers" target="_blank">Learn more</a> about professional plans for teams and commercial use.</span>
      </p>
    </div>
    <img class="art__image" src="assets/images/signup-art.png"/>
  </ng-container>

  <!-- Log In -->
  <ng-container *ngSwitchCase="'login'">
    <div class="art__text">
      <h3>New in the BioDigital Human</h3>
      <h1>Human Studio, the first product for authoring custom interactive 3D models of anatomy, disease and treatments</h1>
    </div>
    <img class="art__image" src="assets/images/login-art.png"/>
  </ng-container>
</div>